import React, { useState } from 'react';
import { endConversation } from '../../../../utils/endConversation';
import { Button } from '@coolblue-development/freddy';

interface CloseConversationProps {
  icon: JSX.Element;
  label: string;
  disabled?: boolean;
  contact: connect.Contact | null;
  onClose?: (onError: () => void) => void;
}

const CloseConversationButton: React.FC<CloseConversationProps> = ({
  icon,
  label,
  disabled,
  contact,
  onClose
}): JSX.Element => {
  const [isClosing, setIsClosing] = useState(false);

  const handleCloseConversation = (): void => {
    if (onClose) {
      setIsClosing(true);
      onClose(() => setIsClosing(false));
      return;
    }
    if (contact) {
      endConversation(contact);
    }
  };

  return (
    <Button
      sx={{
        background: '#E50000',
        boxShadow: 'inset 0 -2px 0 #AA2222',
        ':hover': {
          background: '#BE0000',
          boxShadow: 'inset 0 -2px 0 #680B0F'
        },
        ':disabled': { background: '#cc9494' }
      }}
      startIcon={icon}
      onClick={handleCloseConversation}
      size="small"
      disabled={disabled || isClosing}
      data-testid="close-conversation-button"
      variant="action"
    >
      {label}
    </Button>
  );
};

export default CloseConversationButton;
